export default __webpack_public_path__ + "static/fti-35f5fe44fce7bdbefaee7cde2ec56f45.webp";